/*
 *
 * Destination constants
 *
 */

export const DEFAULT_ACTION = 'app/Destination/DEFAULT_ACTION';
